import http from './http'
import cookies from 'vue-cookies'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://transfer.backend-pier.com'

/**
 * Получение информации о данных промокода
 * @param {string} promoCode - код промокода
 * @returns {Promise<{data: any, error: string}|null>} Данные заказа с возможной ошибкой или null
 */
export const getPromoInfo = async (promoCode = '') => {
  try {
    const params = new URLSearchParams({
      code: promoCode
    })

    const url = `${API_BASE_URL}/promo?${params.toString()}`
    const accessToken = cookies.get('access_token')
    const response = await http.get(url, accessToken)

    if (response.statusCode === 200 || response.statusCode === 201) {
      const { data } = response.data

      return {
        data
      }
    }

    return null
  } catch (error) {
    console.error('Error in promo:', error)
    return null
  }
}
